import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  /* padding: 2rem; */
  padding: ${({ hasReport }) => (hasReport ? "2rem" : "0")};

  .report-detail-container {
    padding: 2rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: linear-gradient(135deg, #203b34 0%, #2d5248 100%); */
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 2rem 3rem;
  border-radius: 12px;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    margin-bottom: 1rem;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const HeaderRight = styled.div``;

export const Title = styled.h3`
  /* font-size: 2.5rem;
  font-weight: bold;
  color: #203b34;
  margin: 0; */
  color: #203b34;
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3); */

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const Year = styled.div`
  font-size: 1.3rem;
  color: #f9ae17;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const EvaluationsBadge = styled.div`
  background-color: #f9ae17;
  color: #203b34;
  padding: 1.5rem 2.5rem;
  border-radius: 12px;
  text-align: center;
  font-weight: bold;
  box-shadow: 0 4px 15px rgba(249, 174, 23, 0.4);

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: 0.95rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }
`;
export const PageLayout = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;
export const ScoreCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
  width: 25%;

  @media (max-width: 1024px) {
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;

export const ScoreCard = styled.div`
  background: ${(props) =>
    props.$primary
      ? "linear-gradient(135deg, #203b34 0%, #2d5248 100%)"
      : "#ffffff"};
  color: ${(props) => (props.$primary ? "#ffffff" : "#203b34")};
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: ${(props) =>
    props.$primary
      ? "0 6px 25px rgba(32, 59, 52, 0.3)"
      : "0 4px 15px rgba(0, 0, 0, 0.1)"};
  border: ${(props) => (props.$primary ? "none" : "2px solid #f9ae17")};
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${(props) =>
      props.$primary
        ? "0 8px 30px rgba(32, 59, 52, 0.4)"
        : "0 6px 20px rgba(0, 0, 0, 0.15)"};
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const ScoreCardIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export const CircularChart = styled.div`
  position: relative;
  /* margin-bottom: 1.5rem; */
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
  }

  circle {
    transition: stroke-dasharray 0.8s ease;
  }

  @media (max-width: 1024px) {
    svg {
      transform: scale(0.85);
    }
  }

  @media (max-width: 480px) {
    svg {
      transform: scale(0.7);
    }
  }
`;

export const ScoreCardTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  opacity: 0.9;
`;

export const ScoreCardValue = styled.div`
  font-size: 3.5rem;
  font-weight: bold;
  color: ${(props) => props.color || "inherit"};

  @media (max-width: 768px) {
    font-size: 3rem;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

export const MainContent = styled.div`
  background-color: #ffffff;
  padding: 3rem;
  border-radius: 12px;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 80%;
  margin-bottom: 2rem;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const ChartsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (max-width: 768px) {
    gap: 2rem;
  }

  @media (max-width: 480px) {
    gap: 1.5rem;
  }
`;

export const ChartBlock = styled.div``;

export const ChartTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #203b34;
  margin: 0 0 2rem 0;
  padding-bottom: 0.75rem;
  /* border-bottom: 4px solid #f9ae17; */
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 1.3rem;
    margin: 0 0 1.5rem 0;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    margin: 0 0 1rem 0;
  }
`;

export const ChartItem = styled.div`
  display: grid;
  grid-template-columns: 220px 1fr 70px;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 150px 1fr 60px;
    gap: 1rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 120px 1fr 50px;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }
`;

export const ChartItemLabel = styled.div`
  font-size: 1rem;
  color: #333;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const ChartItemBar = styled.div`
  height: 35px;
  background-color: #e8ecf1;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    height: 30px;
  }

  @media (max-width: 480px) {
    height: 25px;
  }
`;

export const ChartItemBarFill = styled.div`
  height: 100%;
  width: ${(props) => props.$width}%;
  background: ${(props) => {
    if (props.$competency) {
      return `linear-gradient(90deg, #f9ae17 0%, #ffcc66 100%)`;
    }
    const colors = [
      "linear-gradient(90deg, #203b34 0%, #2d5248 100%)",
      "linear-gradient(90deg, #2d5248 0%, #3a6659 100%)",
      "linear-gradient(90deg, #3a6659 0%, #47796a 100%)",
      "linear-gradient(90deg, #47796a 0%, #548c7b 100%)",
      "linear-gradient(90deg, #548c7b 0%, #619f8c 100%)",
    ];
    return colors[props.$index % colors.length];
  }};
  transition: width 0.6s ease;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

export const ChartItemValue = styled.div`
  font-size: 1.1rem;
  font-weight: bold;
  color: #203b34;
  text-align: right;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;
